// extracted by mini-css-extract-plugin
module.exports = {"container":"full-width-module__container___nCnbz","containerPadding":"full-width-module__containerPadding___jaFCY"};